/**
 * Announce links that open in a new tab.
 *
 * A `target="_blank"` link changes the user's context with no warning: the
 * back button stops working, and a screen reader reads the new page as if
 * nothing happened. WCAG's advice (G201) is to say so up front, in the link's
 * own accessible name.
 *
 * Done here rather than in each template because most of these links are
 * editor-authored — a WYSIWYG "open in new tab" checkbox can land the
 * attribute on any link on the site.
 *
 * Same-host links are skipped: they open a new tab too, but the sentence
 * mostly matters where it also signals "you're leaving the site".
 */
const HINT = ' (opens in a new tab)';

export default function initNewTabHints() {
	const links = document.querySelectorAll('a[target="_blank"]');

	links.forEach((link) => {
		// An author who already spelled it out doesn't need it twice.
		const name = (link.getAttribute('aria-label') || link.textContent || '').toLowerCase();
		if (name.includes('new tab') || name.includes('new window')) return;
		if (link.querySelector('[data-new-tab-hint]')) return;

		// `rel` belongs with the behaviour: an unguarded _blank hands the new
		// document a live `window.opener` reference back to this one.
		const rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
		if (!rel.includes('noopener')) rel.push('noopener');
		if (!rel.includes('noreferrer')) rel.push('noreferrer');
		link.setAttribute('rel', rel.join(' '));

		const hint = document.createElement('span');
		hint.className = 'visually-hidden';
		hint.dataset.newTabHint = '';
		hint.textContent = HINT;
		link.appendChild(hint);
	});
}
